import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Table } from "react-bootstrap";
import {
  getPlayerRecentPaymentReceiptByHistoryId,
  getPlayerRecentPaymentReceiptById,
} from "../../services/academicService";
import { amountToWords } from "../../utils/helperFunction";
import { toPng } from "html-to-image";

const PlayerReciptHistoryModal = ({ show, onClose, userData }) => {
  const [receipt, setReceipt] = useState(null);

  useEffect(() => {
    if (userData?.id) fetchReceipt();
  }, [userData?.id]);

  async function fetchReceipt() {
    try {
      const res = await getPlayerRecentPaymentReceiptByHistoryId(userData.id);
      setReceipt(res);
    } catch (e) {
      console.error(e);
    }
  }

  const handlePrint = () => {
    const printArea = document.getElementById("receipt-print");
    if (!printArea) return;

    const win = window.open("", "", "width=900,height=650");
    if (!win) {
      window.alert("Please allow popups to print the receipt.");
      return;
    }

    win.document.write(`
      <html>
        <head>
          <title>Payment Receipt</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css">
          <style>
            @page {
              size: A4;
              margin: 12mm;
            }

            body {
              margin: 0;
              color: #000;
              font-size: 14px;
              line-height: 1.35;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            .print-wrapper {
              width: 190mm;
              max-width: 100%;
              margin: 0 auto;
            }

            #receipt-print {
              border: 1px solid #000 !important;
              padding: 12px !important;
            }

            #receipt-print table {
              width: 100%;
              border-collapse: collapse;
            }

            #receipt-print td,
            #receipt-print th {
              border: 1px solid #000 !important;
              padding: 6px 8px;
              vertical-align: top;
            }

            #receipt-print h4 {
              font-size: 20px;
              margin-bottom: 4px;
            }

            #receipt-print h6 {
              font-size: 14px;
            }

            #receipt-print small,
            #receipt-print .small {
              font-size: 12px !important;
            }
          </style>
        </head>
        <body>
          <div class="print-wrapper">${printArea.innerHTML}</div>
        </body>
      </html>
    `);
    win.document.close();
    win.focus();
    win.onload = () => {
      win.print();
      win.close();
    };
  };

  const handleShare = async () => {
    try {
      const printArea = document.getElementById("receipt-print");
      if (!printArea) return;

      const dataUrl = await toPng(printArea, {
        cacheBust: true,
        pixelRatio: 2,
        backgroundColor: "#ffffff",
      });

      const blob = await (await fetch(dataUrl)).blob();
      const file = new File([blob], "PaymentReceipt.png", {
        type: "image/png",
      });

      const downloadReceipt = () => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "PaymentReceipt.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

      if (navigator.share) {
        const canShareFiles =
          typeof navigator.canShare === "function" &&
          navigator.canShare({ files: [file] });

        if (canShareFiles) {
          await navigator.share({
            title: "Payment Receipt",
            text: "Payment Receipt",
            files: [file],
          });
          return;
        }

        // Some browsers support share sheet but not file attachment.
        await navigator.share({
          title: "Payment Receipt",
          text: "Payment Receipt",
          url: window.location.href,
        });
        downloadReceipt();
        window.alert(
          "Receipt image downloaded. Attach it from downloads in share app.",
        );
        return;
      }

      downloadReceipt();
      window.alert(
        "Share is not supported on this browser. Receipt downloaded as image.",
      );
    } catch (error) {
      console.error("Share failed:", error);
      const isUserCancel =
        error?.name === "AbortError" ||
        String(error?.message || "")
          .toLowerCase()
          .includes("cancel");
      if (!isUserCancel) {
        window.alert("Unable to share receipt right now. Please try again.");
      }
    }
  };

  // const handleShare = async () => {
  //   try {
  //     const printArea = document.getElementById("receipt-print");

  //     // Capture the receipt
  //     const canvas = await html2canvas(printArea, {
  //       scale: 2,
  //       useCORS: true,
  //       backgroundColor: "#ffffff",
  //     });

  //     const imgData = canvas.toDataURL("image/png");

  //     // Create PDF (same as print)
  //     const pdf = new jsPDF("p", "mm", "a4");

  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();

  //     const imgWidth = pageWidth;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     let heightLeft = imgHeight;
  //     let position = 0;

  //     // First page
  //     pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  //     heightLeft -= pageHeight;

  //     // Multiple pages if required
  //     while (heightLeft > 0) {
  //       position = heightLeft - imgHeight;
  //       pdf.addPage();
  //       pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  //       heightLeft -= pageHeight;
  //     }

  //     // Convert PDF to Blob
  //     const pdfBlob = pdf.output("blob");

  //     const file = new File([pdfBlob], "PaymentReceipt.pdf", {
  //       type: "application/pdf",
  //     });

  //     // Share if supported
  //     if (
  //       navigator.share &&
  //       navigator.canShare &&
  //       navigator.canShare({ files: [file] })
  //     ) {
  //       await navigator.share({
  //         title: "Payment Receipt",
  //         text: "Payment Receipt",
  //         files: [file],
  //       });
  //     } else {
  //       // Fallback: download PDF
  //       pdf.save("PaymentReceipt.pdf");
  //     }
  //   } catch (err) {
  //     console.error("Share failed:", err);
  //   }
  // };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Payment Receipt</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div id="receipt-print" className="border p-3">
          {/* HEADER */}
          <Row className="text-center border-bottom pb-3 mb-4">
            <Col>
              {/* Academy / Tenant Name */}
              <h4 className="fw-bold mb-1 text-uppercase">
                {receipt?.tenant?.name}
              </h4>

              {/* Address */}
              <div className="text-muted small">
                <div className="text-muted small">
                  {receipt?.tenant?.address}
                </div>
              </div>

              {/* Contact Info */}
              <div className="mt-1 d-flex justify-content-center align-items-center flex-wrap gap-4 small text-muted">
                <span>
                  <strong>Email:</strong> {receipt?.tenant?.email}
                </span>
                <span>
                  <strong>Phone:</strong> {receipt?.tenant?.phone}
                </span>
              </div>

              {/* Divider */}
              <hr
                className="my-2"
                style={{ width: "60%", marginInline: "auto" }}
              />

              {/* Receipt Title */}
              <h6 className="fw-bold letter-spacing-1">PAYMENT RECEIPT</h6>
            </Col>
          </Row>

          {/* META */}
          <Row className="mb-2">
            <Col md={6}>
              <strong>S. No:</strong> {receipt?.sno}
            </Col>
            <Col md={6} className="text-end">
              <strong>Date:</strong> {receipt?.date}
            </Col>
          </Row>

          {/* DETAILS */}
          <Table bordered size="sm">
            <tbody>
              <tr>
                <td>
                  <strong>Academic Year</strong>
                </td>
                <td>{receipt?.academicYear}</td>
              </tr>
              <tr>
                <td>
                  <strong>Name of Student</strong>
                </td>
                <td>{receipt?.player?.name}</td>
              </tr>
              <tr>
                <td>
                  <strong>Address</strong>
                </td>
                <td>{receipt?.player?.address || "-"}</td>
              </tr>
              <tr>
                <td>
                  <strong>Package</strong>
                </td>
                <td>{receipt?.subscriptionId?.packageType?.name || "-"}</td>
              </tr>
              <tr>
                <td>
                  <strong>Package Amount</strong>
                </td>
                <td>
                  {receipt?.player?.playerSubscription?.payableAmount || "-"}
                </td>
              </tr>

              <tr>
                <td>
                  <strong>Package Purchase date</strong>
                </td>
                <td>{receipt?.player?.playerSubscription?.startDate || "-"}</td>
              </tr>

              <tr>
                <td>
                  <strong>Package Renewal Date</strong>
                </td>
                <td>{receipt?.player?.playerSubscription?.endDate || "-"}</td>
              </tr>

              <tr>
                <td>
                  <strong>Paid Amount</strong>
                </td>
                <td>{receipt?.amount || "-"}</td>
              </tr>
              <tr>
                <td>
                  <strong>Paid Amount (in words)</strong>
                </td>
                <td>{amountToWords(receipt?.amount)}</td>
              </tr>
              <tr>
                <td>
                  <strong>Balance Amount</strong>
                </td>
                <td>₹{userData?.dueAmount || "0"}</td>
              </tr>
              <tr>
                <td>
                  <strong>Transaction Id</strong>
                </td>
                <td>{userData?.receiptNumber || "Cash"}</td>
              </tr>
              <tr>
                <td>
                  <strong>Mode of Payment</strong>
                </td>
                <td>{userData?.paymentType || "Cash"}</td>
              </tr>
              {receipt?.player?.paymentStatus === "Partial" && (
                <>
                  <tr>
                    <td>
                      <strong>Next Due Amount</strong>
                    </td>
                    <td>₹{receipt?.player?.dueAmount || "0"}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Next Due Date</strong>
                    </td>
                    <td>
                      {receipt?.player?.playerSubscription?.nextDueDate || "_"}
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </Table>

          {/* TOTAL + SIGNATURE */}
          {/* TOTAL AMOUNT (LEFT) + SIGNATURE (RIGHT) */}
          <Row className="mt-5 align-items-end">
            {/* LEFT : TOTAL AMOUNT */}
            <Col md={6} className="text-start">
              <div
                style={{
                  border: "1px solid #000",
                  padding: "6px 12px",
                  display: "inline-block",
                  minWidth: "120px",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                Paid : ₹ {receipt?.amount || "0"}
              </div>
            </Col>

            {/* RIGHT : SIGNATURE */}
            <Col md={6} className="text-end">
              <div>
                <small>Signature of Director</small>
              </div>
              <div
                style={{
                  borderTop: "1px solid #000",
                  width: "200px",
                  marginLeft: "auto",
                  marginTop: "4px",
                }}
              />
              <div>
                <small className="text-muted">
                  Computer generated receipt - signature not required
                </small>
              </div>
              <div>
                <small className="text-muted">
                  Receipt Generated using CrickPay
                </small>
              </div>
            </Col>
          </Row>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handlePrint}>
          Print
        </Button>
        <Button variant="primary" onClick={handleShare}>
          Share
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PlayerReciptHistoryModal;
